import React, { forwardRef, Component } from 'react';
import parse from 'html-react-parser';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';

import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
//import Calendar from './index';
import Box from '@material-ui/core/Box';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Modal from '@material-ui/core/Modal';
import {
  myFormatPrice,
  myFormatDate2,
  formatPrice,
  getMyDate3,
  getMyDate2,
  getMyDate,
  myGetNumber,
} from '../../../@jumbo/utils/commonHelper';
import Grid from '@material-ui/core/Grid';
import MaterialTable from 'material-table';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import MuiAlert from '@material-ui/lab/Alert';
import { injectIntl } from 'react-intl';
import AddPayment from './AddPayment';
import SelectFolio from './SelectFolio';
import DeleteIcon from '@material-ui/icons/Delete';
import { MoveToInbox } from '@material-ui/icons';
import Swal from 'sweetalert2';
import ViewClient from '../timeline/ViewClient.js';
import { DatePicker } from '@material-ui/pickers';

const mycolumns = [
  { title: <IntlMessages id="invoice.item" />, field: 'item' },
  { title: <IntlMessages id="invoice.quantity" />, field: 'quantity', type: 'numeric' },
  {
    title: <IntlMessages id="invoice.value" />,
    field: 'valueNet2',
    type: 'numeric',
    editable: 'never',
  },
  {
    title: <IntlMessages id="invoice.tax" />,
    field: 'tax',
    type: 'numeric',
  },
  {
    title: <IntlMessages id="invoice.totalNet" />,
    field: 'value',
    editable: 'never',
  },
  {
    title: <IntlMessages id="invoice.totalTax" />,
    field: 'valueVat',

    editable: 'never',
  },
  {
    title: <IntlMessages id="invoice.total" />,
    field: 'valueTotal',
  },
];

function roundToTwo(num) {
  return +(Math.round(num + 'e+2') + 'e-2');
}
function MyAlert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const useStyles = theme => ({
  boxClass: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  boxTop: {
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card: {
    overflow: 'unset',
    marginBottom: theme.typography.pxToRem(16),
  },
  cardContent: {
    position: 'relative',
    paddingBottom: 0,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
});

const style = {
  position: 'absolute',
  top: '0%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function createData(name, dateOfBirth) {
  return { name, dateOfBirth };
}

class Invoice extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.calculateTotal = this.calculateTotal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.eventClick = this.eventClick.bind(this);
    this.handleCustomChange = this.handleCustomChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.paymentType = this.paymentType.bind(this);
    this.reload = this.reload.bind(this);
    var today = new Date();

    this.state = {
      issued: {},
      general: {},
      viewClientVisible: false,
      data: [],
      dataf: [],
      folioId: 0,
      payments: [],
      rows: [],
      myanchorEl: null,
      comment: '',
      canCreate: 0,
      selectFolioVisible: false,
      ap: [],
      canCancel: 0,
      canR1: false,
      generalR1: 0,

      invoiceId: 0,
      addPaymentVisible: false,
      addPaymentValue: 0,
      confirmationLanguage: this.props.auth.authUser.language,
      amountLeft: 0,
      canSetDate: false,
      invoiceDate: getMyDate(today),
      myInvoice: null,
      prepayment: this.props.prepayment,
      hotelId: this.props.auth.authUser.hotels[0].id,
      bookingId: this.props.bookingId,
    };
  }
  handleClickOpen() {
    //  setOpen(true);
  }

  handleChange(name, value, index = -1) {
    if (value == null) return;
    if (index == -1) {
      this.setState({ [name]: value }, () => {
        //   this.updateRooms();
      });
    } else {
      this.setState(
        prevState => {
          const data = [...prevState.data];
          var index2 = data.findIndex(({ id }) => id == index);
          data[index2][name] = value;
          if (name == 'service_id') {
            data[index2]['tax'] = this.props.auth.authUser.services.find(({ ID }) => ID == value).Tax;
            if (
              this.props.auth.authUser.services.find(({ ID }) => ID == value).PNP != null &&
              this.props.auth.authUser.services.find(({ ID }) => ID == value).PNP > 0
            )
              data[index2]['pnp'] = this.props.auth.authUser.services.find(({ ID }) => ID == value).PNP;
            else data[index2]['pnp'] = 0;
            var tp = this.props.auth.authUser.services.find(({ ID }) => ID == data[index2]['service_id']).Price;
            if (tp == null || tp == undefined) tp = data[index2]['value'];
            data[index2]['valueTotal'] = myFormatPrice(
              parseFloat(myGetNumber(data[index2]['quantity'], this.props.auth.authUser.numberMode)) * tp,
              this.props.auth.authUser.numberMode,
            );
            data[index2]['value'] = tp;
          }
          if (name == 'quantity') {
            var tp = this.props.auth.authUser.services.find(({ ID }) => ID == data[index2]['service_id']).Price;
            if (tp == null || tp == undefined) tp = data[index2]['value'];
            data[index2]['valueTotal'] = myFormatPrice(
              parseFloat(myGetNumber(value, this.props.auth.authUser.numberMode)) * tp,
              this.props.auth.authUser.numberMode,
            );
          }
          //data[index2]['Tax'] = 1;
          return { data: data };
        },
        () => {
          this.calculateTotal();
        },
      );
    }
  }

  paymentType(type) {
    const { intl } = this.props;

    if (type == 'C') return intl.formatMessage({ id: 'payments.cash' });
    if (type == 'CC') return intl.formatMessage({ id: 'payments.creditCard' });
    if (type == 'BA') return intl.formatMessage({ id: 'payments.bankAccount' });
    if (type == 'PP') return intl.formatMessage({ id: 'payments.prepayment' });
    return '';
  }

  eventClick(args, args2) {
    const { intl } = this.props;
    //    setOpenRes(true);
    if (args == 'findClient') {
      this.setState({ viewClientVisible: true });
    }
    if (args == 'addPayment') {
      var x = 0;
      x = this.state.total;
      this.state.payments.forEach(function(item) {
        x -= parseFloat(item.amount);
      });
      this.setState({ amountLeft: x, addPaymentVisible: true });
    }
    if (args == 'addPrePayment') {
      if (parseFloat(args2.amount) > 0)
        this.setState(
          prevState => {
            var oldPayments = [...prevState.payments];
            var i = oldPayments.filter(function(item) {
              return item.prepayment_id == args2.prepayment_id;
            });
            if (i == null || i.length == 0) oldPayments.push(args2);
            return { payments: oldPayments };
          },
          () => {
            this.calculateTotal();
          },
        );
    }
    if (args == 'updateItems') {
      this.prepareHotel('update', this.state.folioId);
    }
    if (args == 'deleteFolio') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'deleteFolio',
        token: token,
        Version: 1,
        Data: {
          folioId: this.state.folioId,
        },
      };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        this.prepareHotel('');
      });
    }
    if (args == 'selectFolio') {
      this.prepareHotel('', args2);
    }
    if (args == 'addFolio') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'addFolio',
        token: token,
        Version: 1,
        Data: {
          bookingId: this.props.bookingId,
        },
      };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        this.prepareHotel('', res.data.id);
      });
    }
    if (args == 'addItem') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'addFolioItem',
        token: token,
        Version: 1,
        Data: {
          folioId: this.state.folioId,
          hotelId: this.state.hotelId,
        },
      };
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.prepareHotel('', this.state.folioId);
      });
      return;
      var defaultServiceId = this.props.auth.authUser.services.find(({ Default }) => Default == 1).ID;
      var defaultServiceTax = this.props.auth.authUser.services.find(({ Default }) => Default == 1).Tax;
      this.setState(
        prevState => {
          const data = [...prevState.data];
          const item = {
            serviceId: defaultServiceId,
            item: '',
            tax: defaultServiceTax,
            pnp: 0,
            folio_id: this.state.folioId,
            valueTotal: 0,
            quantity: 1,
            valueNet: 0,
          };
          data.push(item);
          return { ...prevState, data };
        },
        () => {
          this.calculateTotal();
        },
      );
    }
    if (args == 'downloadInvoice' && this.state.myInvoice != null) {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'downloadInvoice',
        token: token,
        Version: 1,
        Data: {
          Language: this.state.confirmationLanguage,
          invoiceId: this.state.myInvoice,
        },
      };

      const config = { responseType: 'blob' };
      const filename = this.state.general.label + '.pdf';
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }
    if (args == 'moveFolioItem') {
      this.setState({ selectedItemId: args2, selectFolioVisible: true });
    }
    if (args == 'moveFolioItem2') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'moveFolioItem',
        token: token,
        Version: 1,
        Data: {
          origFolioId: this.state.folioId,
          itemId: this.state.selectedItemId,
          newFolioId: args2,
        },
      };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        this.prepareHotel('', this.state.folioId);
      });
    }
    if (args == 'deleteItem') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'deleteFolioItem',
        token: token,
        Version: 1,
        Data: {
          folioId: this.state.folioId,
          folioItemId: args2,
        },
      };
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.prepareHotel('', this.state.folioId);
      });
      return;

      this.setState(
        prevState => {
          const data = [...prevState.data];
          var index2 = data.findIndex(({ id }) => id == args2);
          data.splice(index2, 1);
          return { ...prevState, data };
        },
        () => {
          this.calculateTotal();
        },
      );
    }
    if (args == 'deletePayment') {
      this.setState(
        prevState => {
          var oldPayments = [...prevState.payments];
          oldPayments.splice(args2, 1);
          return { payments: oldPayments };
        },
        () => {
          this.calculateTotal();
        },
      );
    }
    if (args == 'payInvoice') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'payInvoice',
        token: token,
        Version: 1,
        Data: {
          invoiceId: this.props.resId,
        },
        General: this.state.general,
      };
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;

      var r = window.confirm(intl.formatMessage({ id: 'invoice.confirmPaid' }));
      if (r == true) {
        axios.post(pmsUrl, senddata).then(res => {
          if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
            localStorage.setItem('token', res.data.newToken);
          }
          this.props.setState({ viewInvoiceVisible: false });
          if (this.props.doRefresh != null) this.props.doRefresh();
        });
      }
    }

    if ((args == 'makeR1' || args == 'deleteInvoice' || args == 'deleteInvoice2') && this.state.myInvoice != null) {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: args,
        token: token,
        Version: 1,
        Data: {
          invoiceId: this.state.myInvoice,
        },
        General: this.state.general,
      };
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;
      var r = false;
      if (args == 'deleteInvoice') r = window.confirm(intl.formatMessage({ id: 'invoice.confirmCancel' }));
      if (args == 'deleteInvoice2') r = window.confirm(intl.formatMessage({ id: 'invoice.confirmCancel2' }));
      if (args == 'makeR1') r = window.confirm(intl.formatMessage({ id: 'invoice.makeR1' }));
      if (r == true) {
        axios.post(pmsUrl, senddata).then(res => {
          if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
            localStorage.setItem('token', res.data.newToken);
          }
          var myinvoice = res.data.id;
          this.props.setState({ viewInvoiceVisible: false, invoiceId: null });

          if (this.props.doRefresh != null) this.props.doRefresh();
          this.prepareHotel();
        });
      }
    }
    if (args == 'viewInvoice') {
      let iid = this.state.invoiceId;
      this.props.setState({ viewInvoiceVisible: true, invoiceId: iid, invoiceMode: 'view', prepayment: 0 });
    }
    if ((args == 'saveFolio' || args == 'createInvoice' || args == 'printFolio') && this.state.prepayment == 0) {
      console.log('data');
      console.log(this.state.data);
      const token = localStorage.getItem('token');
      var datax = JSON.parse(JSON.stringify(this.state.data));
      var dataf = datax.filter(
        function(item) {
          return item.folio_id == this.state.folioId;
        }.bind(this),
      );
      console.log(dataf);
      for (var j = 0; j < dataf.length; j++) {
        dataf[j].quantity = myGetNumber(dataf[j].quantity, this.props.auth.authUser.numberMode);
        dataf[j].valueTotal = myGetNumber(dataf[j].valueTotal, this.props.auth.authUser.numberMode);
      }
      console.log(dataf);
      const senddata = {
        Action: 'saveFolio',
        token: token,
        Version: 1,

        Data: {
          folioId: this.state.folioId,
          hotelId: this.state.hotelId,
          bookingId: this.props.bookingId,
          data: dataf,
          payments: this.state.payments,
        },
        General: {
          name: this.state.generalName,
          address: this.state.generalAddress,
          city: this.state.generalCity,
          country: this.state.generalCountry,
          vatid: this.state.generalVatId,
          r1: this.state.generalR1,
          comment: this.state.comment,
        },
      };
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;

      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (args == 'printFolio') {
          const token = localStorage.getItem('token');
          const senddata = {
            Action: 'downloadFolio',
            token: token,
            Version: 1,
            Data: {
              Language: this.state.confirmationLanguage,
              folioId: this.state.folioId,
            },
          };

          const config = { responseType: 'blob' };
          var f = this.state.dataf.filter(
            function(item) {
              return (item.id = this.state.folioId);
            }.bind(this),
          );
          var filename = 'undefined';
          if (f != null) filename = f[0].name + '.pdf';

          axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
            //this.props.setState({ lastEvents: [], running2: false });
            //if (this.props.doRefresh != null) this.props.doRefresh();
            //this.refresh();
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
          });
        }
        if (args == 'createInvoice') {
          const token = localStorage.getItem('token');
          /*var dataf = this.state.data.filter(
            function(item) {
              return item.folio_id == this.state.folioId;
            }.bind(this),
          );
          for (var j = 0; j < dataf.length; j++) {
            dataf[j].quantity = myGetNumber(dataf[j].quantity, this.props.auth.authUser.numberMode);
            dataf[j].valueTotal = myGetNumber(dataf[j].valueTotal, this.props.auth.authUser.numberMode);
          }*/

          const senddata = {
            Action: 'createInvoice',
            token: token,
            Version: 1,
            Data: {
              folioId: this.state.folioId,
              hotelId: this.state.hotelId,
              bookingId: this.props.bookingId,
              data: dataf,
              payments: this.state.payments,
            },
            General: {
              name: this.state.generalName,
              r1: this.state.generalR1,
              address: this.state.generalAddress,
              city: this.state.generalCity,
              country: this.state.generalCountry,
              vatid: this.state.generalVatId,
              comment: this.state.comment,
              currency: this.state.general.currency,
              date: getMyDate(this.state.invoiceDate),
            },
          };
          if (args2 != null && args2 != undefined && args2 == 1) senddata.Data.check = 1;
          var pmsUrl = this.props.auth.authUser.pmsUrl;
          if (pmsUrl == '') return;

          axios.post(pmsUrl, senddata).then(res => {
            if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
              localStorage.setItem('token', res.data.newToken);
            }
            var myinvoice = res.data.id;
            var check = res.data.check;
            if (check != null && check != undefined && check == 1) {
              var iec = '';
              if (res.data.message == 1) iec = intl.formatMessage({ id: 'invoiceCreateError2' });
              if (res.data.message == 2) iec = intl.formatMessage({ id: 'invoiceCreateError3' });
              Swal.fire({
                title: intl.formatMessage({ id: 'notification.error' }),
                text: iec,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: intl.formatMessage({ id: 'yes' }),
                cancelButtonText: intl.formatMessage({ id: 'no' }),
              }).then(result => {
                if (result.isConfirmed) {
                  this.eventClick('createInvoice', 1);
                } else return;
              });
            } else if (myinvoice != null && myinvoice != undefined && myinvoice != '') {
              this.props.setState({ invoiceMode: 'view', viewInvoiceVisible: true, invoiceId: myinvoice });

              if (this.props.doRefresh != null) this.props.doRefresh();
              this.prepareHotel();
            } else {
              var iec = intl.formatMessage({ id: 'invoiceCreateError' });
              if (res.data.errorMessage != '') iec += '\n\n' + res.data.errorMessage;
              Swal.fire({
                title: intl.formatMessage({ id: 'notification.error' }),
                text: iec,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: intl.formatMessage({ id: 'ok' }),
              }).then(result => {
                return;
              });
            }
          });
        }
      });
    }
    if (args == 'createInvoice' && this.state.prepayment == 1) {
      const token = localStorage.getItem('token');
      var dataf = this.state.data;
      for (var j = 0; j < dataf.length; j++) {
        dataf[j].quantity = myGetNumber(dataf[j].quantity, this.props.auth.authUser.numberMode);
        dataf[j].valueTotal = myGetNumber(dataf[j].valueTotal, this.props.auth.authUser.numberMode);
      }

      const senddata = {
        Action: 'createInvoice',
        token: token,
        Version: 1,
        Data: {
          hotelId: this.state.hotelId,
          bookingId: this.props.bookingId,
          data: dataf,
          payments: this.state.payments,
          prepayment: this.state.prepayment,
        },
        General: {
          name: this.state.generalName,
          r1: this.state.generalR1,
          address: this.state.generalAddress,
          city: this.state.generalCity,
          country: this.state.generalCountry,
          vatid: this.state.generalVatId,
          comment: this.state.comment,
          currency: this.state.general.currency,
          date: getMyDate(this.state.invoiceDate),
        },
      };
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;

      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        var myinvoice = res.data.id;
        if (myinvoice != null && myinvoice != undefined) {
          this.props.setState({ viewMode: 0, viewInvoiceVisible: true, invoiceMode: 'view', invoiceId: myinvoice });
          this.reload();
          if (this.props.doRefresh != null) this.props.doRefresh();
        } else {
          var iec = intl.formatMessage({ id: 'invoiceCreateError' });
          Swal.fire({
            title: intl.formatMessage({ id: 'notification.error' }),
            text: iec,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: intl.formatMessage({ id: 'ok' }),
          }).then(result => {
            return;
          });
        }
      });
    } else {
    }
    //alert(this.state.selReservationId);
  }

  handleClick(event, action) {}

  calculateTotal() {
    var totalNet = 0,
      totalTax = 0,
      totalPnp = 0,
      total = 0,
      iid = 0;
    console.log(this.state.data);
    var data = this.state.data;
    data
      .filter(
        function(item) {
          if (this.props.viewMode == 0) return true;
          if (this.props.viewMode == 1) return item.folio_id == this.state.folioId;
        }.bind(this),
      )
      .forEach((item, index) => {
        console.log(this.props.auth.authUser.numberMode);
        console.log(item.valueTotal);
        console.log(item.tax);
        console.log(item.pnp);

        item.value = roundToTwo(
          myGetNumber(item.valueTotal, this.props.auth.authUser.numberMode) /
            (1 +
              myGetNumber(item.tax, this.props.auth.authUser.numberMode) / 100 +
              myGetNumber(item.pnp, this.props.auth.authUser.numberMode) / 100),
        );
        console.log(item.value);
        if (item.pnp > 0) item.valuePnp = roundToTwo((item.value * item.pnp) / 100);
        else item.valuePnp = 0;
        totalPnp += item.valuePnp;
        item.valueVat = roundToTwo(
          myGetNumber(item.valueTotal, this.props.auth.authUser.numberMode) - item.value - item.valuePnp,
        );
        console.log(item.valueVat);
        item.valueNet2 = roundToTwo(item.value / myGetNumber(item.quantity, this.props.auth.authUser.numberMode));
        console.log(item.quantity);
        console.log(item.valueNet2);
        //item.valueTax = roundToTwo(item.valueTax);
        //item.valueTotal = item.valueNet + item.valueTax;
        //item.valueTotal = roundToTwo(item.valueTotal);
        totalNet += item.value;
        totalTax += item.valueVat;
        total += roundToTwo(myGetNumber(item.valueTotal, this.props.auth.authUser.numberMode));
        //      item.item2 = parse(item.item);
        item.tax = item.tax;
        if (item.invoice_id != null && item.invoice_id != 0 && this.props.viewMode == 1) iid = item.invoice_id;
      });
    this.setState({
      total: total,
      invoiceId: iid,
      totalNet: totalNet,
      totalTax: totalTax,
      totalPnp: totalPnp,
    });

    var result = 1,
      result2 = true;
    var message = '';
    const { intl } = this.props;
    if (this.state.data.length == 0) {
      result = 0;
      message = intl.formatMessage({ id: 'invoice.noItems' });
      result2 = false;
    }

    if (result == 1 && this.state.payments.length == 0) {
      result = 0;
      message = intl.formatMessage({ id: 'invoice.noPayments' });
      result2 = false;
    }

    var totalPayment = 0;
    this.state.payments.forEach(function(item) {
      totalPayment += parseFloat(item.amount);
    });
    console.log(totalPayment);
    console.log(total);
    if (result == 1 && formatPrice(totalPayment, 'en', 2) != formatPrice(total, 'en', 2)) {
      result = 0;
      message = intl.formatMessage({ id: 'invoice.error1' });
      result2 = false;
    }
    if (this.state.prepayment == 1 && this.state.data.length > 1) {
      result = 0;
      message = intl.formatMessage({ id: 'invoice.error2' });
      result2 = false;
    }
    if (this.state.prepayment == 1 && this.state.payments.length > 1) {
      result = 0;
      message = intl.formatMessage({ id: 'invoice.error3' });
      result2 = false;
    }
    if (iid != 0) {
      result = 0;
      message = intl.formatMessage({ id: 'invoice.folioClosedInvoiceCreated' });
      result2 = false;
    }

    this.setState({
      canSetDate: result2,
      canCreate: result,
      message: message,
    });
  }

  prepareHotel(action2 = '', id2 = '') {
    let myhotelId = this.state.hotelId;
    if (this.props.hotelId != null) myhotelId = this.props.hotelId;
    const token = localStorage.getItem('token');
    var action = '';
    if (this.props.bookingId == null) return;
    if (this.props.viewMode == 0) action = 'getInvoice';
    else action = 'getFolios';
    const senddata = {
      Action: action,
      token: token,
      Version: 1,
      Data: {
        hotelId: myhotelId,
        bookingId: this.props.bookingId,
        prepayment: this.props.prepayment,
        action: action2,
      },
    };
    if (action2 == 'update') senddata.Data.folioId = this.state.folioId;
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      var mycode = '';
      if (res.data.qr != '' && res.data.qr != null)
        mycode = 'http://api.qrserver.com/v1/create-qr-code/?data=' + escape(res.data.qr) + '&size=100x100';

      if (this.props.viewMode == 0) {
        var myfD = res.data.Data;
        for (var j = 0; j < myfD.length; j++) {
          myfD[j].quantity = myFormatPrice(parseFloat(myfD[j].quantity), this.props.auth.authUser.numberMode);
          myfD[j].tax = myFormatPrice(parseFloat(myfD[j].tax), this.props.auth.authUser.numberMode);
          myfD[j].valueTotal = myFormatPrice(parseFloat(myfD[j].valueTotal), this.props.auth.authUser.numberMode);
        }

        this.setState(
          {
            hotelId: myhotelId,
            data: myfD,
            issued: res.data.Issued,
            general: res.data.General,
            generalName: res.data.General.name,
            generalAddress: res.data.General.address,
            generalCity: res.data.General.city,
            generalCountry: res.data.General.country,
            generalVatId: res.data.General.vatid,
            prepayment: res.data.General.prepayment,
            generalR1: res.data.General.r1,
            payments: res.data.payments,
            qrCode: mycode,
            canCancel: res.data.General.canCancel,
            canR1: res.data.General.r1 == '0',
            comment: res.data.General.comment,
          },
          () => {
            this.calculateTotal();
          },
        );
      }
      if (this.props.viewMode == 1) {
        let fi = res.data.Data.f[0].id;
        let i = 0;
        if (id2 != '') {
          fi = id2;
          i = res.data.Data.fd.findIndex(({ id }) => id == fi);
          if (i == -1 || i == null) i = 0;
        }

        var generalName = '',
          generalAddress = '',
          generalCity = '',
          generalCountry = '',
          generalVatid = '',
          generalR1 = 0;
        if (res.data.Data.fd.length > 0) {
          generalName = res.data.Data.fd[i].name;
          generalAddress = res.data.Data.fd[i].address;
          generalCity = res.data.Data.fd[i].city;
          generalCountry = res.data.Data.fd[i].country;
          generalVatid = res.data.Data.fd[i].vatid;
          generalR1 = res.data.Data.fd[i].r1;
        }
        var myfD = res.data.Data.fd;
        for (var j = 0; j < myfD.length; j++) {
          myfD[j].quantity = myFormatPrice(myfD[j].quantity, this.props.auth.authUser.numberMode);
          myfD[j].valueTotal = myFormatPrice(myfD[j].valueTotal, this.props.auth.authUser.numberMode);
        }

        this.setState(
          {
            hotelId: myhotelId,
            dataf: res.data.Data.f,
            data: myfD,
            folioId: fi,
            generalName: generalName,
            generalAddress: generalAddress,
            generalCity: generalCity,
            generalCountry: generalCountry,
            generalVatId: generalVatid,
            generalR1: generalR1,
            payments: [],
            ap: res.data.Data.ap,
          },
          () => {
            this.calculateTotal();
          },
        );
      }
    });
  }

  reload() {
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'getInvoice',
      token: token,
      Version: 1,
      Data: {
        invoiceId: this.props.resId,
      },
    };
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      var mycode = '';
      if (res.data.qr != '')
        mycode = 'http://api.qrserver.com/v1/create-qr-code/?data=' + escape(res.data.qr) + '&size=100x100';

      if (res.data.Data != null) {
        var myfD = res.data.Data;
        for (var j = 0; j < myfD.length; j++) {
          myfD[j].quantity = myFormatPrice(parseFloat(myfD[j].quantity), this.props.auth.authUser.numberMode);
          myfD[j].valueTotal = myFormatPrice(parseFloat(myfD[j].valueTotal), this.props.auth.authUser.numberMode);
        }

        myfD.forEach((item, index) => {
          //            item.valueNet2 = item.value / item.quantity;
          //              item.value = roundToTwo(item.valueTotal / (1 + item.tax / 100));
          //              item.valueVat = roundToTwo(item.valueTotal - item.value);
          item.valueNet2 = roundToTwo(
            item.value / parseFloat(myGetNumber(item.quantity, this.props.auth.authUser.numberMode)),
          );

          //          item.valueTax = (item.value * item.quantity * item.tax) / 100;
          //item.valueTotal = item.value
          /*totalNet += item.valueNet;
          totalTax += item.valueTax;
          total += item.valueTotal;*/
          item.tax = item.tax;
        });
        this.setState(
          {
            data: myfD,
            issued: res.data.Issued,
            general: res.data.General,
            generalName: res.data.General.name,
            generalAddress: res.data.General.address,
            generalCity: res.data.General.city,
            generalCountry: res.data.General.country,
            generalVatId: res.data.General.vatid,
            generalR1: res.data.General.r1,
            prepayment: res.data.General.prepayment,
            payments: res.data.payments,
            qrCode: mycode,
            myInvoice: this.props.resId,
            canCancel: res.data.General.canCancel,
            canR1: res.data.General.r1 == '0',
          },
          () => {
            this.calculateTotal();
          },
        );
      } else this.props.setState({ resDetailsVisible: false });
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log('update');
    console.log(prevProps);
    console.log(this.props);
    if (prevProps.prepayment != this.state.prepayment && prevProps.prepayment != null) {
      this.setState({ prepayment: this.props.prepayment });
    }
    if (
      (prevProps.open != this.props.open && this.props.open == true) ||
      prevProps.bookingId != this.props.bookingId ||
      (prevProps.hotelId != this.props.hotelId && this.props.bookingId != null)
    ) {
      if (/*prevProps.mode != this.props.mode &&*/ this.props.mode == 'create') {
        //this.setState({hotelId: this.props.hotelId, })
        this.prepareHotel();
        /*} else if (prevProps.bookingId !== this.props.bookingId && this.props.bookingId != '') {
        this.prepareHotel();*/
      } /* if (prevProps.resId !== this.props.resId && this.props.resId != '') */ else {
        //      this.setState({ resId: this.props.resId });
        this.reload();
      }
    }
  }

  componentDidMount() {
    console.log('create');
    console.log(this.props);
    if (this.props.viewMode == 1) this.prepareHotel();
  }

  handleClose() {
    this.props.setState({ viewInvoiceVisible: false });
    //  setOpen(false);
  }

  handleCustomChange(event, owner) {
    if (event.target != null) this.setState({ [owner]: event.target.value }, () => {});
  }

  render() {
    const { classes } = this.props;
    var hotels = this.props.auth.authUser.hotels;
    const columns = mycolumns.map(column => {
      return { ...column };
    });

    //    let moj = (
    /*

 */
    let children = (
      <div>
        <Box className={classes.boxTop}>
          {this.props.status == 2 && (
            <>
              <MyAlert severity="warning">
                <IntlMessages id={'invoice.thisInvoiceWasCancelled'} />
              </MyAlert>
              <br />
            </>
          )}
          {this.state.canCreate == 0 && (
            <>
              <MyAlert severity="warning">{this.state.message}</MyAlert>
              <br />
            </>
          )}

          <Grid container spacing={1}>
            {this.props.mode == 'create' && (
              <Grid item xs={12}>
                <Box ml={6}></Box>
              </Grid>
            )}
            {this.props.mode != 'create' && (
              <>
                <Grid item xs={12}>
                  <Box ml={6}>
                    <Box fontSize={16} color="text.secondary">
                      {this.state.prepayment == 0 && <IntlMessages id="invoice.type0" />}
                      {this.state.prepayment == 1 && <IntlMessages id="invoice.type1" />}
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box ml={6}>
                    <Box fontSize={12} color="text.secondary">
                      <IntlMessages id="invoice.label" />
                    </Box>
                  </Box>
                  <Box ml={6}>
                    <Box className={classes.columnRoot}>{this.state.general.label}</Box>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box ml={6}>
                    <Box fontSize={12} color="text.secondary">
                      <IntlMessages id="invoice.createdDate" />
                    </Box>
                    <Box className={classes.columnRoot}>
                      {getMyDate3(this.state.general.datetime2, this.props.auth.authUser.language)}
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
            <Grid item xs={6}>
              <Box ml={6}>
                <Box fontSize={12} color="text.secondary">
                  <IntlMessages id="viewClient.name" />
                </Box>
                <Box className={classes.columnRoot}>
                  {(this.props.mode != 'create' || this.state.invoiceId != 0) && (
                    <>
                      {this.state.canR1 == false && <h1>R1</h1>}
                      {this.state.generalName}
                      <br />
                      {this.state.generalAddress}
                      <br />
                      {this.state.generalCity}
                      <br />
                      {this.state.generalCountry}
                      <br />
                      {this.state.generalVatId != '' && <IntlMessages id="invoice.taxId" />} {this.state.generalVatId}
                      <br />
                      {this.state.generalR1 == 1 && <IntlMessages id="R1" />}
                    </>
                  )}

                  {this.props.mode == 'create' && this.state.invoiceId == 0 && (
                    <>
                      <TextField
                        id="standard-basic"
                        placeholder="name"
                        label=""
                        value={this.state.generalName}
                        onChange={event => this.handleChange('generalName', event.target.value)}
                      />
                      <br />
                      <TextField
                        id="standard-basic"
                        placeholder="address"
                        label=""
                        value={this.state.generalAddress}
                        onChange={event => this.handleChange('generalAddress', event.target.value)}
                      />
                      <br />
                      <TextField
                        id="standard-basic"
                        placeholder="city"
                        label=""
                        value={this.state.generalCity}
                        onChange={event => this.handleChange('generalCity', event.target.value)}
                      />
                      <br />
                      <TextField
                        id="standard-basic"
                        placeholder="country"
                        label=""
                        value={this.state.generalCountry}
                        onChange={event => this.handleChange('generalCountry', event.target.value)}
                      />
                      <br />
                      <TextField
                        id="standard-basic"
                        label=""
                        placeholder="vatid"
                        value={this.state.generalVatId}
                        onChange={event => this.handleChange('generalVatId', event.target.value)}
                      />
                      <br />
                      <TextField
                        id="standard-basic"
                        label=""
                        placeholder="vatid"
                        value={this.state.generalR1}
                        select
                        onChange={event => this.handleChange('generalR1', event.target.value)}>
                        <MenuItem value={0}>
                          <IntlMessages id="noR1" />
                        </MenuItem>
                        <MenuItem value={1}>
                          <IntlMessages id="R1" />
                        </MenuItem>
                      </TextField>
                      <br />
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        className={classes.myButton}
                        onClick={e => this.eventClick('findClient')}>
                        <IntlMessages id="findClient2" />
                      </Button>
                    </>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={6}>
              {this.props.viewMode == 0 && (
                <Box ml={6}>
                  <Box fontSize={12} color="text.secondary">
                    <IntlMessages id="invoice.issuedBy" />
                  </Box>
                  <Box className={classes.columnRoot}>
                    {this.props.mode == 'view' && this.state.invoiceId != 0 && (
                      <>
                        {this.state.canR1 == false && <h1>R1</h1>}
                        {this.state.issued.propertyname}
                        <br />
                        {this.state.issued.companyname}
                        <br />
                        {this.state.issued.companyaddress}
                        <br />
                        {this.state.issued.companycity}
                        <br />
                        {this.state.issued.companycountry}
                        <br />
                        <IntlMessages id="invoice.taxId" />
                        {this.state.issued.companytaxid}
                        <br />
                      </>
                    )}
                    {this.props.mode == 'create' && this.state.invoiceId == 0 && (
                      <>
                        <Select
                          id="hotelId"
                          name="hotelId"
                          value={this.state.hotelId}
                          onChange={event => this.handleCustomChange(event, 'hotelId')}>
                          {hotels.map((t, idx) => (
                            <MenuItem value={t.id}>{t.name}</MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                  </Box>
                </Box>
              )}
            </Grid>
          </Grid>
          <Box className={classes.boxClass}>
            {this.props.mode == 'create' && this.state.invoiceId == 0 && (
              <Button variant="contained" color="secondary" onClick={() => this.eventClick('addItem')}>
                <IntlMessages id="invoice.addItem" />
              </Button>
            )}
            {this.props.mode == 'create' && this.state.invoiceId == 0 && (
              <Button variant="contained" color="secondary" onClick={() => this.eventClick('updateItems')}>
                <IntlMessages id="invoice.updateAccommodation" />
              </Button>
            )}
            {this.props.mode == 'create' &&
              this.state.invoiceId == 0 &&
              this.state.data.filter(
                function(item) {
                  if (this.props.viewMode == 0) return true;
                  if (this.props.viewMode == 1) return item.folio_id == this.state.folioId;
                }.bind(this),
              ).length == 0 && (
                <Button variant="contained" color="secondary" onClick={() => this.eventClick('deleteFolio')}>
                  <IntlMessages id="invoice.deleteFolio" />
                </Button>
              )}
          </Box>

          <TableContainer component={Paper} className={classes.root}>
            <Table className={classes.table} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>
                    <IntlMessages id="invoice.item" />
                  </TableCell>
                  <TableCell width="50" align="right">
                    <IntlMessages id="invoice.quantity" />
                  </TableCell>
                  <TableCell width="150" align="right">
                    <IntlMessages id="invoice.value" />
                  </TableCell>

                  <TableCell width="150" align="right">
                    <IntlMessages id="invoice.tax" />
                  </TableCell>
                  <TableCell width="150" align="right">
                    <IntlMessages id="invoice.totalNet" />
                  </TableCell>
                  <TableCell width="150" align="right">
                    <IntlMessages id="invoice.totalTax" />
                  </TableCell>

                  <TableCell width="150" align="right">
                    <IntlMessages id="invoice.total" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.data
                  .filter(
                    function(item) {
                      if (this.props.viewMode == 0) return true;
                      if (this.props.viewMode == 1) return item.folio_id == this.state.folioId;
                    }.bind(this),
                  )
                  .map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell>
                        {this.props.mode == 'create' && this.state.invoiceId == 0 && (
                          <IconButton onClick={() => this.eventClick('deleteItem', row.id)}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                        {this.props.mode == 'create' && this.state.invoiceId == 0 && (
                          <IconButton onClick={() => this.eventClick('moveFolioItem', row.id)}>
                            <MoveToInbox />
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {(this.props.mode != 'create' || this.state.invoiceId != 0) && <>{row.item}</>}
                        {this.props.mode == 'create' && this.state.invoiceId == 0 && (
                          <>
                            {this.state.prepayment == 0 && (
                              <>
                                <TextField
                                  label={<IntlMessages id="res.service" />}
                                  id="service_id"
                                  name="service_id"
                                  fullWidth
                                  select
                                  margin="normal"
                                  className={classes.currency}
                                  value={row.service_id}
                                  onChange={event => this.handleChange('service_id', event.target.value, row.id)}>
                                  {this.props.auth.authUser.services
                                    .filter(
                                      function(itemx) {
                                        return itemx.hotelid == this.state.hotelId;
                                      }.bind(this),
                                    )
                                    .map((t, idx) => (
                                      <MenuItem value={t.ID}>{t.Name}</MenuItem>
                                    ))}
                                </TextField>
                                <br />
                              </>
                            )}
                            <TextField
                              fullWidth
                              onChange={event => this.handleChange('item', event.target.value, row.id)}
                              value={row.item}></TextField>
                          </>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {this.props.mode == 'create' && this.state.invoiceId == 0 && this.state.prepayment == 0 && (
                          <TextField
                            onChange={event => this.handleChange('quantity', event.target.value, row.id)}
                            fullWidth
                            value={row.quantity}
                          />
                        )}
                        {(this.props.mode != 'create' || this.state.invoiceId != 0) && <>{row.quantity}</>}
                      </TableCell>
                      <TableCell align="right">
                        {myFormatPrice(row.valueNet2, this.props.auth.authUser.numberMode)}
                      </TableCell>
                      <TableCell align="right">
                        {myFormatPrice(row.tax, this.props.auth.authUser.numberMode)}
                        {row.pnp > 0 && (
                          <>
                            {' + '}
                            {myFormatPrice(row.pnp, this.props.auth.authUser.numberMode)}
                          </>
                        )}
                      </TableCell>
                      <TableCell align="right">{myFormatPrice(row.value, this.props.auth.authUser.numberMode)}</TableCell>
                      <TableCell align="right">
                        {myFormatPrice(row.valueVat, this.props.auth.authUser.numberMode)}
                        {row.pnp > 0 && (
                          <>
                            {' + '}
                            {myFormatPrice(row.valuePnp, this.props.auth.authUser.numberMode)}
                          </>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {this.props.mode == 'create' && this.state.invoiceId == 0 && (
                          <TextField
                            onChange={event => this.handleChange('valueTotal', event.target.value, row.id)}
                            fullWidth
                            value={row.valueTotal}
                          />
                        )}
                        {(this.props.mode != 'create' || this.state.invoiceId != 0) && <>{row.valueTotal}</>}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className={classes.boxTop}>
            <Grid container spacing={1}>
              <Grid item xs={12} xl={9} sm={9}></Grid>
              <Grid item xs={12} xl={3} sm={3}>
                <Box ml={6}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Box>
                        <IntlMessages id="invoice.totalNet" />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="flex-end">
                        {myFormatPrice(parseFloat(this.state.totalNet), this.props.auth.authUser.nubmerMode)}{' '}
                        {this.state.general.currency}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Box>
                        <IntlMessages id="invoice.totalTax" />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="flex-end">
                        {myFormatPrice(parseFloat(this.state.totalTax), this.props.auth.authUser.numberMode)}{' '}
                        {this.state.general.currency}
                      </Box>
                    </Grid>
                  </Grid>
                  {this.state.totalPnp != 0 && (
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Box>
                          <IntlMessages id="invoice.totalPnp" />
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box display="flex" justifyContent="flex-end">
                          {myFormatPrice(parseFloat(this.state.totalPnp), this.props.auth.authUser.numberMode)}{' '}
                          {this.state.general.currency}
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Box>
                        <IntlMessages id="invoice.total" />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="flex-end">
                        {myFormatPrice(parseFloat(this.state.total), this.props.auth.authUser.numberMode)}{' '}
                        {this.state.general.currency}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {this.state.invoiceId == 0 && (
            <Box className={classes.boxTop}>
              <Grid container spacing={1}>
                <Grid item xs={12} xl={9} sm={9}></Grid>
                <Grid item xs={12} xl={3} sm={3}>
                  <Box ml={6}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Box>
                          <b>
                            <IntlMessages id="invoice.payments" />
                          </b>
                          {this.state.canCreate == 0 && this.props.mode == 'create' && (
                            <Button onClick={() => this.eventClick('addPayment')} variant="contained" color="secondary">
                              <IntlMessages id="invoice.addPayment" />
                            </Button>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                    {this.state.payments.map((item, index) => (
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Box>
                            {this.paymentType(item.type)}
                            {item.label != undefined ? '(' + item.label + ')' : ''}
                            {this.props.mode == 'create' && (
                              <Button onClick={() => this.eventClick('deletePayment', index)}>
                                <IntlMessages id="invoice.deletePayment" />
                              </Button>
                            )}
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box display="flex" justifyContent="flex-end">
                            {myFormatPrice(parseFloat(item.amount), this.props.auth.authUser.numberMode)}{' '}
                            {this.state.general.currency}
                          </Box>
                        </Grid>
                      </Grid>
                    ))}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}

          {this.props.mode == 'create' && this.state.invoiceId == 0 && this.props.viewMode == 1 && this.state.ap.length > 0 && (
            <Box>
              {this.state.ap.map(
                function(item) {
                  return (
                    <MyAlert severity="info">
                      <IntlMessages id={'invoice.unusedPrepayment'} />
                      {myFormatPrice(item.totalleft, this.props.auth.authUser.numberMode)}{' '}
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={() =>
                          this.eventClick('addPrePayment', {
                            type: 'PP',
                            amount: item.totalleft < this.state.total ? item.totalleft : this.state.total,

                            prepayment_id: item.id,
                          })
                        }>
                        <IntlMessages id={'invoice.usePrepayment'} />
                      </Button>
                    </MyAlert>
                  );
                }.bind(this),
              )}
            </Box>
          )}

          <Box>
            {this.props.mode == 'view' && this.state.general.comment}
            {this.props.mode == 'create' && this.state.invoiceId == 0 /*&& this.props.viewMode == 0*/ && (
              <TextField
                label={<IntlMessages id="res.guestComments" />}
                id="comment"
                name="comment"
                margin="normal"
                rows={6}
                variant="outlined"
                fullWidth
                multiline="true"
                value={this.state.comment}
                onChange={event => this.handleChange('comment', event.target.value)}
              />
            )}
          </Box>

          {this.props.viewMode == 0 && (
            <Box>
              {this.state.general.zki != '' && this.state.general.zki != null && <>ZKI:</>} {this.state.general.zki}
              {this.state.general.jir != '' && this.state.general.jir != null && (
                <>
                  <br />
                  JIR:
                </>
              )}{' '}
              {this.state.general.jir}
            </Box>
          )}
          {this.props.viewMode == 0 && (
            <Box>{this.state.qrCode != '' && this.state.qrCode != null && <img src={this.state.qrCode} alt="" />}</Box>
          )}
          {this.props.mode == 'create' && this.state.invoiceId == 0 && this.state.canSetDate == true && (
            <Box className={classes.boxClass}>
              <FormControl variant="filled" className={classes.formControl}>
                <DatePicker
                  variant="inline"
                  format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                  margin="normal"
                  id="date1"
                  name="date1"
                  label={<IntlMessages id="date" />}
                  autoOk="true"
                  value={this.state.invoiceDate}
                  onChange={date => {
                    this.setState({ invoiceDate: date }, () => {
                      //if (cloudUser == 0) this.checkOffers();
                    });
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </FormControl>
            </Box>
          )}

          {this.props.mode == 'create' && this.props.viewMode == 1 && this.state.invoiceId == 0 && (
            <>
              <Button variant="contained" color="secondary" onClick={() => this.eventClick('saveFolio')}>
                <IntlMessages id="invoice.saveFolio" />
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => this.eventClick('printFolio')}
                style={{ marginLeft: '5px' }}>
                <IntlMessages id="invoice.printFolio" />
              </Button>
            </>
          )}

          {this.props.mode == 'create' && this.state.invoiceId == 0 && (
            <Button
              variant="contained"
              disabled={this.state.canCreate == 0}
              color="secondary"
              onClick={() => this.eventClick('createInvoice')}
              style={{ marginLeft: '5px' }}>
              <IntlMessages id="invoices.createInvoice" />
            </Button>
          )}
          {this.props.mode == 'create' && this.state.invoiceId != 0 && this.props.viewMode == 1 && (
            <Button variant="contained" color="secondary" onClick={() => this.eventClick('viewInvoice')}>
              <IntlMessages id="bookings.viewInvoice" />
            </Button>
          )}
          {this.props.mode == 'view' && this.state.canR1 == true && (
            <FormControl variant="filled" className={classes.formControl}>
              <Button variant="contained" color="secondary" onClick={() => this.eventClick('makeR1')}>
                <IntlMessages id="invoice.makeR1" />
              </Button>
            </FormControl>
          )}
          {this.props.mode == 'view' && this.state.canCancel == 1 && (
            <>
              <FormControl variant="filled" className={classes.formControl}>
                <Button variant="contained" color="secondary" onClick={() => this.eventClick('deleteInvoice')}>
                  <IntlMessages id="invoices.cancelInvoice" />
                </Button>
              </FormControl>
              <FormControl variant="filled" className={classes.formControl}>
                <Button variant="contained" color="secondary" onClick={() => this.eventClick('deleteInvoice2')}>
                  <IntlMessages id="invoices.deleteInvoice" />
                </Button>
              </FormControl>
            </>
          )}
          {this.props.mode == 'view' && this.props.status == 1 && (
            <FormControl variant="filled" className={classes.formControl}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.eventClick('payInvoice')}
                style={{ marginLeft: '5px' }}>
                <IntlMessages id="invoices.setAsPaid" />
              </Button>
            </FormControl>
          )}
        </Box>

        {this.props.mode == 'view' && (
          <Box className={classes.boxClass}>
            <TextField
              id="priceModel"
              name="RoomId"
              select
              size="small"
              inputProps={{ min: 0, style: { textAlign: 'center' } }}
              margin="small"
              variant="outlined"
              className={classes.textFieldRoot2}
              value={this.state.confirmationLanguage}
              onChange={event => this.handleChange('confirmationLanguage', event.target.value)}>
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="hr">Croatian</MenuItem>
            </TextField>

            <FormControl variant="filled" className={classes.formControl}>
              <Button variant="contained" color="secondary" onClick={() => this.eventClick('downloadInvoice')}>
                <IntlMessages id="invoice.downloadPDF" />
              </Button>
            </FormControl>
          </Box>
        )}

        <SelectFolio
          open={this.state.selectFolioVisible}
          anchorEl={this.state.myanchorEl}
          folios={this.state.dataf}
          moveFolio={p => {
            this.eventClick('moveFolioItem2', p);
          }}
          setState={p => {
            this.setState(p);
          }}
        />
        <ViewClient
          resId={-1}
          open={this.state.viewClientVisible}
          setState={p => {
            this.setState(p);
          }}
        />

        <AddPayment
          open={this.state.addPaymentVisible}
          anchorEl={this.state.myanchorEl}
          hotelId={this.state.hotelId}
          prepayment={this.state.prepayment}
          amount={myFormatPrice(this.state.amountLeft, this.props.auth.authUser.numberMode)}
          addPayment={p => {
            if (parseFloat(p.amount) > 0)
              this.setState(
                prevState => {
                  var oldPayments = [...prevState.payments];
                  oldPayments.push(p);
                  return { payments: oldPayments };
                },
                () => {
                  this.calculateTotal();
                },
              );
          }}
          setState={p => {
            this.setState(p);
          }}
        />
      </div>
    );

    if (this.props.viewMode == 1)
      return (
        <>
          <Box className={classes.boxClass}>
            {this.state.dataf.map(item => (
              <Button variant="contained" color="secondary" onClick={() => this.eventClick('selectFolio', item.id)}>
                {item.name}
              </Button>
            ))}
            <Button variant="contained" color="secondary" onClick={() => this.eventClick('addFolio')}>
              <IntlMessages id="invoice.addFolio" />
            </Button>
          </Box>
          <CmtCard className={classes.card}>
            <CmtCardContent className={classes.cardContent}>{children}</CmtCardContent>
          </CmtCard>
        </>
      );
    else
      return (
        <Dialog fullScreen open={this.props.open} onClose={this.handleClose} hideBackdrop>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                {this.state.prepayment == 0 && <IntlMessages id="invoice.type0" />}
                {this.state.prepayment == 1 && <IntlMessages id="invoice.type1" />} {this.props.resTitle}
              </Typography>
            </Toolbar>
          </AppBar>
          {children}
        </Dialog>
      );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(Invoice)));
